export default function tryParseGuid(str?: string | null): string | null {
    if (!str) {
        return null;
    }

    const guidRegex =
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

    if (guidRegex.test(str)) {
        return str;
    }

    return null;
}
